import { useEffect, useState, useImperativeHandle, forwardRef } from 'react';
import { Paper, Chip, CircularProgress } from '../../../../ui';
import { toast } from 'react-toastify';
import {
  ICostCenterHistoryItem,
} from '../../../../@types/cost-center-history.type';
import { getCostCenterHistoryByResourceId } from '../../../../services/api/resource/costCenterHistoryService';
import styles from './styles.module.scss';

interface CostCenterHistoryProps {
  resourceId?: string | null;
}

export interface CostCenterHistoryRef {
  refresh: () => Promise<void>;
}

export const CostCenterHistory = forwardRef<CostCenterHistoryRef, CostCenterHistoryProps>(
  ({ resourceId }, ref) => {
    const [loading, setLoading] = useState(false);
    const [history, setHistory] = useState<ICostCenterHistoryItem[]>([]);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const fetchHistory = async () => {
      if (!resourceId) return;

      try {
        setLoading(true);
        const data = await getCostCenterHistoryByResourceId(resourceId);
        setHistory(data);
      } catch (error: any) {
        toast.error('Erro ao carregar histórico de centro de custo');
        console.log(error)
        setHistory([]);
      } finally {
        setLoading(false);
      }
    };

    useImperativeHandle(ref, () => ({
      refresh: async () => {
        await fetchHistory();
      },
    }));

    useEffect(() => {
      fetchHistory();
    }, [resourceId, refreshTrigger]);

  const displayHistory = [...history].slice(0, 3);

  return loading ? (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <CircularProgress size={100} />
    </div>
  ) : !history || history.length === 0 ? (
    <Paper className={styles.projectPaper}>
      <div>Nenhum histórico de centro de custo disponível</div>
    </Paper>
  ) : (
    <div className={styles.container}>
      <h3 className={styles.title}>Histórico de Centro de Custo</h3>
      <div className={styles.gridWrapper}>
        {displayHistory.map((record, index) => (
          <Paper
            key={record.id}
            className={`${styles.recordCard} ${index === 0 ? styles.firstRecord : ''}`}
          >
            <div className={styles.recordGrid}>
              <div className={styles.gridItem}>
                <span className={styles.label}>Centro de Custo</span>
                <Chip
                  label={record.costCenterName}
                  variant="filled"
                  size="small"
                  className={styles.costCenterChip}
                />
              </div>
              <div className={styles.gridItem}>
                <span className={styles.label}>Início</span>
                <div className={styles.value}>{record.startDate}</div>
              </div>
              <div className={styles.gridItem}>
                <span className={styles.label}>Fim</span>
                <div className={styles.value}>{record.endDate || 'Atual'}</div>
              </div>
              <div className={styles.gridItem}>
                <span className={styles.label}>Autor</span>
                <div className={styles.value}>{record.author}</div>
              </div>
            </div>
          </Paper>
        ))}
      </div>
    </div>
  );
});

CostCenterHistory.displayName = 'CostCenterHistory';
